import e from "./RenderString.vue.script.js";
//#region src/schema/RenderString.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=RenderString.vue.js.map